import {
  IColumnDef,
  IExtendableDto,
  ITableFixedColumnNames,
} from "@ryde/shared";

export const getFixedColumnsNamesFromTableDef = <T extends IExtendableDto>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tableDef: IColumnDef<T, any>[],
): ITableFixedColumnNames => {
  const { fixedColumns, lastColumns } = tableDef.reduce(
    (acc, column) => {
      const { fixed, last } = column?.meta || {};

      if (!column.id) {
        return acc;
      }

      if (fixed) {
        acc.fixedColumns.push(column.id);
      }

      if (last) {
        acc.lastColumns.push(column.id);
      }

      return acc;
    },
    { fixedColumns: [] as string[], lastColumns: [] as string[] },
  );

  return { fixedColumns, lastColumns };
};
